import { render } from "./AlertModal.vue?vue&type=template&id=b39d288c&scoped=true&ts=true"
import script from "./AlertModal.vue?vue&type=script&lang=ts"
export * from "./AlertModal.vue?vue&type=script&lang=ts"

import "./AlertModal.vue?vue&type=style&index=0&id=b39d288c&lang=css"
import "./AlertModal.vue?vue&type=style&index=1&id=b39d288c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39d288c"]])

export default __exports__